import axios from 'axios';

import { IModelDParameter } from '@/shared/model/model-d-parameter.model';

const baseApiUrl = 'api/model-d-parameters';

export default class ModelDParameterService {
  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IModelDParameter): Promise<IModelDParameter> {
    return new Promise<IModelDParameter>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public reset(parameterId: number): Promise<IModelDParameter> {
    return new Promise<IModelDParameter>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/reset/${parameterId}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
